import { API } from 'constants/api';

declare global {
    interface Window {
        __API?: typeof API;
    }
}

/** Установка API в константы из window */
export function bootstrapApi() {
    if (window.__API) {
        Object.entries(window.__API).forEach(([_apiName, apiValue]) => {
            const apiName = _apiName as keyof typeof API;

            API[apiName] = apiValue;
        });
        delete window.__API;
    }
}
